export const SESSION_STICKY_VIEW_QUERY_OPTIONS = {
  staleTime: Infinity,
  gcTime: Infinity,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;

export const OWNER_PORTAL_SETTINGS_QUERY_KEY: string[] = [
  'settings',
  'owner-portal-settings',
];

export const OWNER_PORTAL_CALENDAR_SETTINGS_QUERY_KEY: string[] = [
  'settings',
  'owner-portal-calendar-settings',
];
